import style from './index.module.scss';
import { ReactComponent as Linkedin } from './linkedin.svg';
import { ReactComponent as Twitter } from './twitter.svg';
import { ReactComponent as Youtube } from './youtube.svg';
import { ReactComponent as Instagram } from './instagram.svg';
import { ReactComponent as Facebook } from './facebook.svg';

export const Socials = ({ socials }) => {
    const numberOfElement = socials
        ? ['youtubeUrl', 'linkedinUrl', 'twitterUrl', 'facebookUrl', 'instagramUrl'].reduce(
              (count, key) => (socials[key] ? count + 1 : count),
              0,
          )
        : 0;

    return (
        <div className={style.socials} style={{ '--nbr-cols': numberOfElement }}>
            {socials && socials.youtubeUrl && (
                <a href={socials.youtubeUrl} target="_blank" rel="noreferrer">
                    <Youtube className={style.socialLogo} />
                </a>
            )}
            {socials && socials.linkedinUrl && (
                <a href={socials.linkedinUrl} target="_blank" rel="noreferrer">
                    <Linkedin className={style.socialLogo} />
                </a>
            )}
            {socials && socials.twitterUrl && (
                <a href={socials.twitterUrl} target="_blank" rel="noreferrer">
                    <Twitter className={style.socialLogo} />
                </a>
            )}
            {socials && socials.facebookUrl && (
                <a href={socials.facebookUrl} target="_blank" rel="noreferrer">
                    <Facebook className={style.socialLogo} />
                </a>
            )}
            {socials && socials.instagramUrl && (
                <a href={socials.instagramUrl} target="_blank" rel="noreferrer">
                    <Instagram className={style.socialLogo} />
                </a>
            )}
        </div>
    );
};
